import styled from "styled-components";

export const CloseIconWrapper = styled.div`
  min-height: 24px;
  min-width: 24px;
  display: flex;
  margin: 16px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
